import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { motion } from 'framer-motion';

import GlimmerAnimation from '@/components/Animations/GlimmerAnimation/GlimmerAnimation';

import css from './styles.module.scss';

import tgemIcon from '/img/tgem.png';

interface OnboardingRewardProps {
  mainText: string;
  isStart: boolean;
  isFinishOnboarding?: boolean;
  tgemIconBounds?: { left: number; top: number; width: number; height: number };
  acountBounds?: { left: number; top: number; width: number; height: number };
}

const OnboardingReward: React.FC<OnboardingRewardProps> = ({
  mainText,
  isStart,
}) => {
  const { t } = useTranslation();

  const tgemRef = useRef<HTMLImageElement>(null);

  return (
    <div className="">
      <div className={cn('flex flex-col justify-start gap-[8px]')}>
        <span className="text-[#747679] font-[500] text-[14px]">
          {t(mainText)}:
        </span>
        <div className="flex justify-between">
          <div className="flex flex-col justify-between relative pl-[45px]">
            <motion.div
              ref={tgemRef}
              className={cn(
                css.imageBlock,
                'absolute w-[40px] h-[40px] top-0 left-0 flex items-center justify-center rounded-1/2',
              )}
            >
              <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 w-[87%] h-[87%] overflow-hidden !rounded-[60%] z-[5]">
                <GlimmerAnimation />
              </div>
              <img src={tgemIcon} alt="coin" className="w-full h-full z-[2]" />
            </motion.div>
            <h2 className="text-[#181A20] text-[14px] font-bold">200 T-Gem</h2>
            <span className="text-[#747679] -mt-[5px] text-[14px]">≈ $3.0</span>
          </div>
        </div>
      </div>
      {isStart && (
        <div className="flex justify-between items-center mt-[12px] mb-[16px]">
          <div className="flex items-center gap-[4px]">
            <svg id="icon-Frame" viewBox="0 0 30 32" width={16}>
              <path
                fill="#747679"
                style={{ fill: 'var(--color1, #747679)' }}
                d="M20.425 18.659l-4.199-3.149v-6.415c0-0.645-0.521-1.166-1.166-1.166s-1.166 0.521-1.166 1.166v6.999c0 0.367 0.173 0.714 0.467 0.933l4.666 3.499c0.201 0.152 0.447 0.234 0.699 0.233 0.356 0 0.706-0.16 0.934-0.468 0.387-0.515 0.282-1.246-0.233-1.632z"
              ></path>
              <path
                fill="#747679"
                style={{ fill: 'var(--color1, #747679)' }}
                d="M15.059 0.941c-8.304 0-15.059 6.755-15.059 15.059s6.755 15.059 15.059 15.059c8.304 0 15.059-6.755 15.059-15.059s-6.755-15.059-15.059-15.059zM15.059 28.726c-7.016 0-12.726-5.71-12.726-12.726s5.71-12.726 12.726-12.726c7.017 0 12.726 5.71 12.726 12.726s-5.71 12.726-12.726 12.726z"
              ></path>
            </svg>
            <span className="text-[#747679] font-[500] text-[14px]">
              {t('Time')}:
            </span>
          </div>
          <span className="text-[#181A20] font-[700] text-[14px]">
            ≈ 1 {t('min')}
          </span>
        </div>
      )}
    </div>
  );
};

export default OnboardingReward;
